import { BaseComponent } from './../base/base.component';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
declare var bootbox:any;
@Component({
  selector: 'app-organizations',
  template: require('./organizations.component.html')
})
export class OrganizationsComponent extends BaseComponent implements OnInit {

  public organizations = [];

  public onlyDemo = false;

  public onlyDemoToggled() {
    this.loadOrganizations();
  }

  ngOnInit() {
    this.loadOrganizations();
  }

  public loadOrganizations() {
    this.destroyDataTable("#tblData");
    this.busy = this.lsApi.getOrganizations(this.onlyDemo).subscribe(resp => {
        if(resp.status) {
            this.organizations = resp.data;
            this.initDataTable(
              "#tblData",
              [
                { "bSearchable": false, bSortable: false }, //col 1
                { "bSearchable": true },  //col 2
                { "bSearchable": true },  //col 3
                { "bSearchable": false, bSortable: false } //col 6 
              ]
            );
            //this.router.navigate([this.router.url]);
        }
    },
    error => {
        console.log(error);
    });
  }

  public downloadExcel(orgId) {
    window.open("/api/v1/DownloadExcelData?orgId=" + orgId)
  }

  public deleteOrganization(org) {
    
    bootbox.confirm({message:"Do you want to delete this organization and all it's data including surveys?<br><small>All the survey and it's data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {


          this.busy = this.lsApi.deleteOrganization(org.organizationId).subscribe(resp => {
            if(resp.status) {
                this.appToast.success("Organization Successfully Deleted","Organization Deleted");
                this.loadOrganizations();
            }
          },
          error => {
            bootbox.alert(error);
          });

          
        }
      }});
  }

  /*
  ngAfterViewInit(){
       
    console.log("Start");

    setTimeout(()=>{    //<<<---    using ()=> syntax
        $.getScript('/static/assets/be/app/js/dashboard.js');
    },1000);
    
    console.log("Done");
  }
  */


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/organizations/organizations.component.ts